"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _react2 = require("@emotion/react");

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _system = _interopRequireWildcard(require("../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  /**
   * The chip will be added relative to this node.
   */
  children: _propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    chip: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),

  /**
   * The color of the chip.
   */
  color: (0, _propTypes.oneOf)(['default', 'primary', 'secondary', 'success']),

  /**
   * The content rendered within the chip.
   */
  content: _propTypes.node,

  /**
   * Use a dot as a chip.
   */
  dot: _propTypes.bool,

  /**
   * Overlap of the chip.
   */
  overlap: (0, _propTypes.oneOf)(['circle', 'square']),

  /**
   * The position of the chip.
   */
  position: (0, _propTypes.oneOf)(['topLeft', 'topRight', 'bottomRight', 'bottomLeft']),

  /**
   * Show a pulse animation.
   */
  pulse: _propTypes.bool
};
var defaultProps = {
  classes: {
    chip: null,
    root: null
  },
  color: 'default',
  content: '',
  dot: false,
  overlap: 'square',
  position: 'topRight',
  pulse: false
};
var ChipRoot = (0, _system["default"])('div')({
  label: 'ChipRoot'
}, {
  display: 'inline-flex',
  flexShrink: 0,
  position: 'relative',
  verticalAlign: 'middle'
}, (0, _system.classesStyles)('root'));
var pulseAnimation = (0, _react2.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n    opacity: 0.3;\n  }\n  60% {\n    transform: scale(1.5);\n    opacity: 0.2;\n  }\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n"])));
var Chip = ( /*#__PURE__*/0, _base["default"])('span', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0, _isPropValid["default"])(prop) && !['color', 'content'].includes(prop);
  },
  target: "ekglaiw0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0, _isPropValid["default"])(prop) && !['color', 'content'].includes(prop);
  },
  target: "ekglaiw0",
  label: "Chip"
})((0, _css["default"])({
  alignContent: 'center',
  alignItems: 'center',
  borderRadius: 'full',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  fontFamily: 'body',
  fontSize: 'xs',
  fontWeight: 'medium',
  height: '20px',
  justifyContent: 'center',
  lineHeight: 'none',
  minWidth: '20px',
  position: 'absolute',
  px: '6px',
  py: 0,
  zIndex: '1'
}), function (_ref) {
  var dot = _ref.dot;
  return dot && (0, _css["default"])({
    height: '8px',
    p: 0,
    minWidth: '8px',
    borderRadius: 'md'
  });
}, function (_ref2) {
  var overlap = _ref2.overlap;
  var pos = overlap === 'circle' ? '14%' : 0;
  return (0, _styledSystem.variant)({
    prop: 'position',
    variants: {
      topLeft: {
        left: pos,
        top: pos,
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%'
      },
      topRight: {
        right: pos,
        top: pos,
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%'
      },
      bottomRight: {
        bottom: pos,
        right: pos,
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%'
      },
      bottomLeft: {
        bottom: pos,
        left: pos,
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%'
      }
    }
  });
}, (0, _styledSystem.variant)({
  prop: 'color',
  variants: {
    "default": {
      bg: 'danger',
      color: 'white'
    },
    primary: {
      bg: 'primary.main',
      color: 'white'
    },
    secondary: {
      bg: 'secondary.main',
      color: 'white'
    },
    success: {
      bg: 'success',
      color: 'white'
    }
  }
}), function (_ref3) {
  var content = _ref3.content,
      pulse = _ref3.pulse;
  return pulse && (0, _css["default"])({
    '::before': {
      alignContent: 'inherit',
      alignItems: 'inherit',
      animation: "".concat(pulseAnimation, " 1.75s infinite"),
      bg: 'inherit',
      borderRadius: 'inherit',
      boxSizing: 'inherit',
      color: 'transparent',
      content: "'".concat(content, "'"),
      display: 'inherit',
      flexDirection: 'inherit',
      flexWrap: 'inherit',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      height: 'inherit',
      justifyContent: 'inherit',
      lineHeight: 'inherit',
      minWidth: 'inherit',
      position: 'inherit',
      px: '3px',
      py: 'inherit',
      zIndex: 'hide'
    }
  });
}, (0, _system.classesStyles)('chip'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var children = _ref4.children,
      content = _ref4.content,
      position = _ref4.position,
      color = _ref4.color,
      pulse = _ref4.pulse,
      dot = _ref4.dot,
      overlap = _ref4.overlap,
      props = _objectWithoutProperties(_ref4, ["children", "content", "position", "color", "pulse", "dot", "overlap"]);

  var chipProps = {
    classes: props.classes,
    color: color,
    content: content,
    dot: dot,
    overlap: overlap,
    position: position,
    pulse: pulse
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ChipRoot, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(Chip, _objectSpread(_objectSpread({}, chipProps), {}, {
      children: content
    }))]
  }));
});
Component.displayName = 'Chip';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Chip.js.map